export const uiPowerUp = {
    name: 'UI Power Up',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        description: {
            name: 'Description',
            type: 'RichText',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [
                { nodes: {} },
                {
                    enabledMarks: ['bold', 'italic', 'underline'],
                    message: 'Only bold, italic, and underline marks are allowed'
                },
                {
                    enabledNodeTypes: ['hyperlink'],
                    message: 'Only link to Url nodes are allowed'
                }
            ]
        },
        buttonText: {
            name: 'Button Text',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        url: {
            name: 'Url',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        image: {
            name: 'Image',
            type: 'Link',
            linkType: 'Asset',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkMimetypeGroup: ['image'] }]
        }
    }
};
//# sourceMappingURL=uiPowerUp.js.map